.wrapper {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
}

* {
  box-sizing: border-box;
}
